import { createSignal, createEffect, onCleanup, splitProps, untrack, } from "solid-js";
import { useMapContext } from "../MapProvider";
export const Control = (props) => {
    const [ctx] = useMapContext();
    const [update, create] = splitProps(props, ["position"]);
    const [control, setControl] = createSignal(null);
    const controlClasses = new Map([
        ["navigation", window.MapLib.NavigationControl],
        ["scale", window.MapLib.ScaleControl],
        ["attribution", window.MapLib.AttributionControl],
        ["geolocate", window.MapLib.GeolocateControl],
        ["fullscreen", window.MapLib.FullscreenControl],
        ["logo", window.MapLib.LogoControl],
        ["terrain", window.MapLib.TerrainControl],
    ]);
    // Add Control
    createEffect(() => {
        untrack(() => control() &&
            ctx.map.hasControl(control()) &&
            ctx.map.removeControl(control()));
        setControl(create.custom ||
            new (controlClasses.get(create.type || "navigation"))(create.options));
    });
    // Update Position
    createEffect(() => {
        ctx.map.hasControl(control()) && ctx.map.removeControl(control());
        ctx.map.addControl(control(), update.position);
    });
    onCleanup(() => {
        ctx.map.hasControl(control()) && ctx.map.removeControl(control());
    });
    return null;
};
